import { EpisodeCategory } from '@common/enums';
import { never } from '@common/utils/never';

export function episodeCategoryIconName(episodeCategory: EpisodeCategory) {
    switch (episodeCategory) {
        case EpisodeCategory.allergology:
        case EpisodeCategory.audiology:
        case EpisodeCategory.bariatrics:
        case EpisodeCategory.cardiology:
        case EpisodeCategory.corona:
        case EpisodeCategory.dermatology:
        case EpisodeCategory.homeconsultation:
        case EpisodeCategory.mentalHealth:
        case EpisodeCategory.neurology:
        case EpisodeCategory.ophthalmology:
        case EpisodeCategory.orthopedics:
        case EpisodeCategory.pulmonology:
        case EpisodeCategory.radiology:
        case EpisodeCategory.somnology:
            return episodeCategory;
        case EpisodeCategory.allergy:
        case EpisodeCategory.endocrinology:
        case EpisodeCategory.general:
        case EpisodeCategory.nephrology:
        case EpisodeCategory.pilot:
        case EpisodeCategory.specialistConsultation:
            return EpisodeCategory.general;
        default:
            return never(episodeCategory);
    }
}
